import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 2,
  label: "年度授权量分析",
  chart: charts.lineAndBar,
  definition: {
    rowDims: [{ name: "pubDate", label: "授权年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    colDims: [],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "年度授权量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false
  }
};
